// HKDSE 2024 Paper 1 Knowledge Graph Samples - Complete Set Part 2
// Continuing with remaining questions from the LaTeX file

export const hkdse2024Samples_complete_part2 = {
  statistics: [
    {
      id: 'hkdse2024_statistics_01',
      problem: "下表顯示某群主婦擁有鑰匙的數目的分佈。Table description: A frequency distribution table with two rows: Row 1 (header): 鑰匙的數目 | 3 | 4 | 5 | 6 | 7 | 8. Row 2: 主婦人數 | 10 | 9 | 4 | 3 | 4 | k. 若從該群中隨機選出一名主婦，則她擁有多於 $6$ 條鑰匙的概率為 $\\frac{5}{18}$。(a) 求 $k$。(b) 寫出該分佈的平均值、眾數及中位數。",
      problemType: "statistics_frequency_distribution",
      difficulty: "intermediate",
      description: "Analyzing frequency distribution with probability",
      graphData: {
        nodes: [
          {
            id: "frequency_table",
            name: "Frequency Table",
            type: "concepts",
            description: "Distribution of keys per housewife",
            value: "3: 10, 4: 9, 5: 4, 6: 3, 7: 4, 8: k",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "probability_given",
            name: "Probability Given",
            type: "concepts",
            description: "P(more than 6 keys) = 5/18",
            value: "P(>6) = 5/18",
            importance: 9,
            x: -200, y: 0, z: 0
          },
          {
            id: "missing_value",
            name: "Missing Value",
            type: "variables",
            description: "k to be determined",
            value: "k",
            importance: 9,
            x: 200, y: 0, z: 0
          },
          {
            id: "statistical_measures",
            name: "Statistical Measures",
            type: "concepts",
            description: "Mean, mode, median",
            value: "Calculate mean, mode, median",
            importance: 8,
            x: 0, y: 200, z: 0
          }
        ],
        links: [
          {
            from: "frequency_table",
            to: "probability_given",
            type: "constrains",
            strength: 9
          },
          {
            from: "probability_given",
            to: "missing_value",
            type: "determines",
            strength: 9
          },
          {
            from: "missing_value",
            to: "statistical_measures",
            type: "enables",
            strength: 8
          }
        ]
      }
    }
  ],
  functions: [
    {
      id: 'hkdse2024_functions_01',
      problem: "已知 $g(x)$ 的一部分為常數，而另一部分則隨 $x$ 正變。假定 $g(-3) = -21$ 及 $g(7) = 9$。(a) 求 $g(x)$。(b) 設 $h(x) = x g(x) + k$，其中 $k$ 為一實常數。若方程 $h(x) = 0$ 所有的根均為實數，求 $k$ 值的範圍。",
      problemType: "functions_direct_variation",
      difficulty: "intermediate",
      description: "Working with functions involving direct variation",
      graphData: {
        nodes: [
          {
            id: "function_structure",
            name: "Function Structure",
            type: "concepts",
            description: "g(x) = constant + kx",
            value: "g(x) = c + kx",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "direct_variation",
            name: "Direct Variation",
            type: "concepts",
            description: "Part varies directly as x",
            value: "kx where k is constant",
            importance: 9,
            x: -200, y: 0, z: 0
          },
          {
            id: "system_equations",
            name: "System of Equations",
            type: "methods",
            description: "Using given values to find constants",
            value: "g(-3) = -21, g(7) = 9",
            importance: 9,
            x: 200, y: 0, z: 0
          },
          {
            id: "real_roots_condition",
            name: "Real Roots Condition",
            type: "concepts",
            description: "All roots of h(x) = 0 are real",
            value: "Find range of k for real roots",
            importance: 8,
            x: 0, y: 200, z: 0
          }
        ],
        links: [
          {
            from: "function_structure",
            to: "direct_variation",
            type: "includes",
            strength: 9
          },
          {
            from: "system_equations",
            to: "function_structure",
            type: "determines",
            strength: 9
          },
          {
            from: "function_structure",
            to: "real_roots_condition",
            type: "enables",
            strength: 8
          }
        ]
      }
    }
  ],
  statistics_advanced: [
    {
      id: 'hkdse2024_statistics_advanced_01',
      problem: "下面的幹葉圖顯示一群研究員在某月內用於閱讀期刊的時數的分佈。Stem-and-leaf plot description: A stem-and-leaf plot with stems 2, 3, 4 and corresponding leaves: Stem 2: leaves 0, 0, 1, a, a, a, 8, 8, 9, 9. Stem 3: leaves 0, 0, 2, 3, 4, 4, 7, 9. Stem 4: leaves 0, b. 該分佈的平均值為 $30$。(a) 求 $a$ 及 $b$。(b) 寫出該分佈的最小可取分佈域。(c) 求該分佈的最大可取四分位數間距。",
      problemType: "statistics_stem_leaf_advanced",
      difficulty: "advanced",
      description: "Analyzing stem-and-leaf diagram with missing values",
      graphData: {
        nodes: [
          {
            id: "stem_leaf_diagram",
            name: "Stem-and-Leaf Diagram",
            type: "concepts",
            description: "Data representation with stems and leaves",
            value: "2|001aaa8899, 3|002344479, 4|0b",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "mean_given",
            name: "Mean Given",
            type: "concepts",
            description: "Mean of distribution is 30",
            value: "Mean = 30",
            importance: 9,
            x: -200, y: 0, z: 0
          },
          {
            id: "missing_values",
            name: "Missing Values",
            type: "variables",
            description: "a and b to be determined",
            value: "a, b",
            importance: 9,
            x: 200, y: 0, z: 0
          },
          {
            id: "range_iqr",
            name: "Range and IQR",
            type: "concepts",
            description: "Minimum range and maximum IQR",
            value: "Calculate range and IQR",
            importance: 8,
            x: 0, y: 200, z: 0
          }
        ],
        links: [
          {
            from: "stem_leaf_diagram",
            to: "mean_given",
            type: "constrains",
            strength: 9
          },
          {
            from: "mean_given",
            to: "missing_values",
            type: "determines",
            strength: 9
          },
          {
            from: "missing_values",
            to: "range_iqr",
            type: "enables",
            strength: 8
          }
        ]
      }
    }
  ],
  coordinate_geometry: [
    {
      id: 'hkdse2024_coordinate_geometry_01',
      problem: "將原點記為 $O$。(a) $A$ 及 $B$ 均為正 $x$ 軸上的點使得 $A$ 的 $x$ 坐標大於 $B$ 的 $x$ 坐標。通過 $B$ 的垂直線與直線 $y = mx$ 相交於點 $C$ 使得 $AB = BC$，其中 $m$ 為一正常數。設 $D$ 為一點使得 $ABCD$ 為一正方形。以 $m$ 表 $OD$ 的斜率。(b) 點 $M$ 及點 $N$ 的坐標分別為 $(6, 5)$ 及 $(10, 0)$。設 $P$ 及 $Q$ 分別為 $OM$ 及 $MN$ 上的點，而 $R$ 及 $S$ 均為 $x$ 軸上的點。若四邊形 $PQRS$ 為一正方形，求 $P$ 的 $x$ 坐標。",
      problemType: "coordinate_geometry_squares",
      difficulty: "advanced",
      description: "Working with coordinate geometry and squares",
      graphData: {
        nodes: [
          {
            id: "square_construction",
            name: "Square Construction",
            type: "concepts",
            description: "Constructing square ABCD",
            value: "ABCD is a square",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "slope_calculation",
            name: "Slope Calculation",
            type: "methods",
            description: "Finding slope of OD in terms of m",
            value: "Slope = (y₂-y₁)/(x₂-x₁)",
            importance: 9,
            x: -200, y: 0, z: 0
          },
          {
            id: "square_pqrs",
            name: "Square PQRS",
            type: "concepts",
            description: "PQRS is a square",
            value: "PQRS is a square",
            importance: 9,
            x: 200, y: 0, z: 0
          },
          {
            id: "x_coordinate",
            name: "X-Coordinate",
            type: "variables",
            description: "X-coordinate of point P",
            value: "P_x",
            importance: 8,
            x: 0, y: 200, z: 0
          }
        ],
        links: [
          {
            from: "square_construction",
            to: "slope_calculation",
            type: "enables",
            strength: 9
          },
          {
            from: "square_pqrs",
            to: "x_coordinate",
            type: "constrains",
            strength: 8
          },
          {
            from: "slope_calculation",
            to: "x_coordinate",
            type: "affects",
            strength: 7
          }
        ]
      }
    }
  ],
  mensuration: [
    {
      id: 'hkdse2024_mensuration_01',
      problem: "某實心直立角錐體的底為一正方形，其邊長為 $64$ cm。該角錐體的高為 $24$ cm。將該角錐體以一平行於其底的平面分成一平截頭體 $X$ 及一角錐體 $Y$。已知 $Y$ 的高為 $18$ cm。(a) 求 $X$ 的體積。(b) 另一實心直立角錐體的底為一正方形。將這角錐體以一平行於其底的平面分成一平截頭體 $Z$ 及一角錐體。$Z$ 的高及總表面面積分別為 $3$ cm 及 $960$ cm$^2$。$X$ 與 $Z$ 是否相似？試解釋你的答案。",
      problemType: "mensuration_pyramid_frustum",
      difficulty: "advanced",
      description: "Working with pyramid, frustum, and similarity",
      graphData: {
        nodes: [
          {
            id: "pyramid_dimensions",
            name: "Pyramid Dimensions",
            type: "concepts",
            description: "Square base and height",
            value: "Base: 64cm, Height: 24cm",
            importance: 9,
            x: 0, y: -200, z: 0
          },
          {
            id: "frustum_volume",
            name: "Frustum Volume",
            type: "methods",
            description: "Calculating volume of frustum X",
            value: "V = (1/3)h(a² + ab + b²)",
            importance: 9,
            x: -200, y: 0, z: 0
          },
          {
            id: "similarity_check",
            name: "Similarity Check",
            type: "concepts",
            description: "Checking if X and Z are similar",
            value: "Compare corresponding ratios",
            importance: 8,
            x: 200, y: 0, z: 0
          },
          {
            id: "surface_area",
            name: "Surface Area",
            type: "concepts",
            description: "Total surface area of Z",
            value: "960 cm²",
            importance: 7,
            x: 0, y: 200, z: 0
          }
        ],
        links: [
          {
            from: "pyramid_dimensions",
            to: "frustum_volume",
            type: "enables",
            strength: 9
          },
          {
            from: "frustum_volume",
            to: "similarity_check",
            type: "enables",
            strength: 8
          },
          {
            from: "surface_area",
            to: "similarity_check",
            type: "provides_data",
            strength: 7
          }
        ]
      }
    }
  ],
  polynomials: [
    {
      id: 'hkdse2024_polynomials_01',
      problem: "設 $F(x) = (6x^2 + x + p)(qx^2 + rx - 10)$，其中 $p$、$q$ 及 $r$ 均為常數。$F(x)$ 的常數項為 $40$。(a) 寫出 $p$ 的值。(b) 當 $F(x)$ 除以 $x + 1$ 時，餘數為 $-12$。已知 $x - 2$ 為 $F(x)$ 的因式。(i) 求 $q$ 及 $r$。(ii) 方程 $F(x) = 0$ 有多少個無理根？試解釋你的答案。",
      problemType: "polynomials_factors_remainder",
      difficulty: "advanced",
      description: "Working with polynomial factors and remainder theorem",
      graphData: {
        nodes: [
          {
            id: "polynomial_structure",
            name: "Polynomial Structure",
            type: "concepts",
            description: "F(x) = (6x² + x + p)(qx² + rx - 10)",
            value: "F(x) = (6x² + x + p)(qx² + rx - 10)",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "constant_term",
            name: "Constant Term",
            type: "concepts",
            description: "Constant term is 40",
            value: "Constant term = 40",
            importance: 9,
            x: -200, y: 0, z: 0
          },
          {
            id: "remainder_theorem",
            name: "Remainder Theorem",
            type: "concepts",
            description: "Remainder when divided by x+1",
            value: "F(-1) = -12",
            importance: 9,
            x: 200, y: 0, z: 0
          },
          {
            id: "irrational_roots",
            name: "Irrational Roots",
            type: "concepts",
            description: "Counting irrational roots of F(x) = 0",
            value: "Use factor theorem and properties",
            importance: 8,
            x: 0, y: 200, z: 0
          }
        ],
        links: [
          {
            from: "polynomial_structure",
            to: "constant_term",
            type: "constrains",
            strength: 9
          },
          {
            from: "polynomial_structure",
            to: "remainder_theorem",
            type: "satisfies",
            strength: 9
          },
          {
            from: "remainder_theorem",
            to: "irrational_roots",
            type: "constrains",
            strength: 8
          }
        ]
      }
    }
  ],
  logarithms: [
    {
      id: 'hkdse2024_logarithms_01',
      problem: "已知 $\\log_9 y$ 為 $\\log_3 x$ 的線性函數。將該線性函數的圖像記為 $L$。$L$ 的斜率為 $4$ 及 $L$ 通過點 $(5, 22)$。以 $x$ 表 $y$。",
      problemType: "logarithms_linear_function",
      difficulty: "intermediate",
      description: "Working with logarithmic linear functions",
      graphData: {
        nodes: [
          {
            id: "logarithmic_relationship",
            name: "Logarithmic Relationship",
            type: "concepts",
            description: "log₉y is linear function of log₃x",
            value: "log₉y = m(log₃x) + c",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "slope_given",
            name: "Slope Given",
            type: "concepts",
            description: "Slope of L is 4",
            value: "m = 4",
            importance: 9,
            x: -200, y: 0, z: 0
          },
          {
            id: "point_given",
            name: "Point Given",
            type: "concepts",
            description: "L passes through (5, 22)",
            value: "Point (5, 22)",
            importance: 9,
            x: 200, y: 0, z: 0
          },
          {
            id: "y_in_terms_of_x",
            name: "Y in Terms of X",
            type: "concepts",
            description: "Express y in terms of x",
            value: "y = f(x)",
            importance: 8,
            x: 0, y: 200, z: 0
          }
        ],
        links: [
          {
            from: "logarithmic_relationship",
            to: "slope_given",
            type: "constrains",
            strength: 9
          },
          {
            from: "logarithmic_relationship",
            to: "point_given",
            type: "satisfies",
            strength: 9
          },
          {
            from: "slope_given",
            to: "y_in_terms_of_x",
            type: "determines",
            strength: 8
          }
        ]
      }
    }
  ],
  probability: [
    {
      id: 'hkdse2024_probability_01',
      problem: "某袋子內有 $16$ 個紅色杯及 $4$ 個白色杯。若從該袋子中隨機同時抽出 $5$ 個杯，求 (a) 抽出恰好 $1$ 個白色杯的概率；(b) 抽出至多 $3$ 個紅色杯的概率。",
      problemType: "probability_combinations",
      difficulty: "intermediate",
      description: "Calculating probabilities using combinations",
      graphData: {
        nodes: [
          {
            id: "cup_distribution",
            name: "Cup Distribution",
            type: "concepts",
            description: "Number of cups of each color",
            value: "Red: 16, White: 4",
            importance: 9,
            x: 0, y: -200, z: 0
          },
          {
            id: "exactly_one_white",
            name: "Exactly One White",
            type: "concepts",
            description: "P(exactly 1 white cup)",
            value: "P(1 white, 4 red)",
            importance: 8,
            x: -200, y: 0, z: 0
          },
          {
            id: "at_most_three_red",
            name: "At Most Three Red",
            type: "concepts",
            description: "P(at most 3 red cups)",
            value: "P(≤3 red) = P(0 red) + P(1 red) + P(2 red) + P(3 red)",
            importance: 8,
            x: 200, y: 0, z: 0
          },
          {
            id: "combinations",
            name: "Combinations",
            type: "methods",
            description: "Using combination formula",
            value: "C(n,r) = n!/(r!(n-r)!)",
            importance: 7,
            x: 0, y: 200, z: 0
          }
        ],
        links: [
          {
            from: "cup_distribution",
            to: "exactly_one_white",
            type: "provides_data",
            strength: 8
          },
          {
            from: "cup_distribution",
            to: "at_most_three_red",
            type: "provides_data",
            strength: 8
          },
          {
            from: "combinations",
            to: "exactly_one_white",
            type: "calculates",
            strength: 7
          }
        ]
      }
    }
  ]
}; 